import { PromiseAction } from '../../actions/commonActions';
import { Action } from 'redux';
import * as api from '../../api/mvnoBundleApi';
import { MvnoBundle, MvnoBundleState } from '../../models/state/mvnoBundle';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { loadMvnoBudlesPending, loadMvnoBudlesFailure, loadMvnoBundlesSuccess } from '../../actions/mvnoBundleActions';
import { ENSURE_MVNO_BUNDLE, INITIAL_AUTHENTICATION, LOAD_MVNO_BUNDLE } from '../../actions/actionTypes';
import { selectMvnoBundle } from '../../selectors/mvnoBundle';

export function* loadMvnoBundleSaga(action: PromiseAction<string, MvnoBundle>) {
  yield put(loadMvnoBudlesPending());
  try {
    const serialNo = action.payload ? action.payload : '';
    const bundle: MvnoBundle = yield call(api.getBundle, serialNo);
    yield put(loadMvnoBundlesSuccess(bundle));
    action.resolve && action.resolve(bundle);
  } catch (error: any) {
    yield put(loadMvnoBudlesFailure(error));
  }
}

export function* ensureMvnoBundleSaga(action: Action) {
  const bundleState: MvnoBundleState = yield select(selectMvnoBundle);
  const { isLoading } = bundleState;
  if (isLoading) {
    return;
  }
  yield call(loadMvnoBundleSaga, action);
}

export function* initMvnoBundlesSagas() {
  yield take(INITIAL_AUTHENTICATION);
  yield takeEvery(ENSURE_MVNO_BUNDLE, ensureMvnoBundleSaga);
  yield takeEvery(LOAD_MVNO_BUNDLE, loadMvnoBundleSaga);
}
